import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'
import editState from '../periodic-check/edit-state'
import metrics from './get-metrics'

const reducer = combineReducers({
  selected,
  all,
  newOne,
  editOne,
  deleteOne,
  editState,
  metrics
})

export default reducer
